import { render, staticRenderFns } from "./kvkk.vue?vue&type=template&id=414471ff&"
import script from "./kvkk.vue?vue&type=script&lang=js&"
export * from "./kvkk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports